export class User {
  public constructor() {}

  public id?: string;
  public drugStoreName?: string;
  public firstName?: string;
  public firstNameValidation?: string;
  public lastName?: string;
  public lastNameValidation?: string;
  public positionName?: string;
  public roleName?: string;
  public username?: string;
  public userNameValidation?: string;
  public password?: string;
  public passwordValidation?: string;
  public validIPAddress?: string;
  public lastActiveIPAddress?: string;
  public mobileNumber?: string;
  public mobileNumberValidation?: string;
  public phoneNumber?: string;
  public phoneNumberValidation?: string;
  public birthday?: string;
  public birthdayValidation?: string;
  public nationalCode?: string;
  public nationalCodeValidation?: string;
  public roleId?: string;
  public drugStoreId?: string;
  public drugStoreIdValidation?: string;
  public positionId?: string;
  public positionIdValidation?: string;
  public imageurl?: string;
}

export class DrugStoreProfile {
  public constructor() {}

  public id?: string;
  public title?: string;
  public salamatUserName?: string;
  public salamatPassword?: string;
  public taminUsername?: string;
  public taminPassword?: string;
  public tokenTamin?: string;
  public tokenSalamat?: string;
  public ttacUsername?: string;
  public ttacPassword?: string;
  public ttacgln?: string;
  public nationalCode?: string;
  public economicalCode?: string;
  public ownerName?: string;
  public phone?: string;
  public phaId?: string;
  public fax?: string;
  public mobile?: string;
  public email?: string;
  public postalCode?: string;
  public address?: string;
}
